module.exports = {
    BOILER: 'boiler',
    COOLING: 'cooling',
    EVAPORATIVE: 'evaporative',
    CLOSED: 'closed',
    CONDENSATE: 'condensate',
    SOFTENER: 'softener',
    DEALKALIZER: 'dealkalizer',
    REVERSE: 'reverse',
    MAKEUP: 'make-up',
    WASTE: 'waste',
    DEMIN: 'demin',
    DOMESTIC: 'domestic',
    FOUNTAIN: 'fountain',
    POLISHER: 'polisher',
    GENERIC: 'generic',
    COUNTER: 'counter',
    WATERVALE: 'water-valve',
    ACUNIT: 'ac-unit',
    RADIATOR: 'radiator',
    HEATINGELEMENT: 'heating-element',
    WATERFILTER: 'water-filter',
    CONTROLLER: 'controller',
    FEEDWATERDEAERATOR: 'feedwater-deaerator',
};
